import styled from 'styled-components'
import colors from 'Assets/colors'
import { media } from 'Config/styled'

export const Input = styled.input`
  width: 100%;
  border-radius: ${props => props.borderRadius};
  border: ${props => props.border};
  padding-right: ${props => (props.suffix ? '30px' : props.padding)};
  transition: all 0.4s;
  font-family: Inter;
  font-size: 16px;
  line-height: 24px;
  height: ${props => props.height};
  color: ${props => props.color || colors.black};
  text-align: left;

  &::placeholder {
    color: ${props => props.placeholderColor};
  }
`

export const Suffix = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: calc(4px + ${({ value }) => `${value?.length * 9}px`});
  color: ${colors.grayDark};
  font-size: 16px;
  pointer-events: none;
`

export const Label = styled.label`
  position: relative;
  width: 100%;
  background: ${props => props.background};
  border-radius: ${props => props.borderRadius};
  border-bottom: ${props => props.borderBottom};
  padding-left: ${props => props.paddingLeft};
  box-shadow: ${props =>
    props.minimalShadow ? '0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12)' : ''};

  .icon-input {
    content: '';
    position: absolute;
    right: ${props => props.rightIcon};
    top: ${props => props.topIcon};
    bottom: 0;
  }

  .close-input-icon {
    content: '';
    position: absolute;
    right: 3rem;
    color: #cccccc;
    width: 22px;
    top: ${props => props.topIcon};
    bottom: 0;
  }

  .close-input-icon:hover {
    color: #acacac;
  }
`

export const Container = styled.div`
  position: relative;
  width: ${props => props.width};
  margin: ${props => props.margin};
  position: ${props => props.position};
  bottom: ${props => props.bottom};
  left: ${props => props.left};
  ${media('lg')} {
    width: ${props => props.respWidth};
  }
`

export const ErrorContainer = styled.div`
  color: ${colors.red};
  padding: 5px 5px 0;
  font-size: 11px;
`

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  display: inline-block;
`
